(function userControllerDefinition() {
    'use strict';

    angular.module('User')
        .controller('UserFindController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'adminUserService', 'storageService', 'authExtend', 'fileDownloader', '$filter',
            function userController($scope, config, $state, $translate, errors, adminUserService, storageService, authExtend, fileDownloader, $filter) {
                $scope.find = storageService.getDocumentFilter();

                $scope.hideAddBtn = !authExtend.isInRole('USER WRITE');
                $scope.hideAddRolesBtn = !authExtend.isInRole('ROLE ASSIGN');
                $scope.items = [];
                $scope.emptyOu = true;

                $scope.findAction = function () {
                    $scope.items = [];
                    $scope.find.showNoData = false;
                    $scope.find.showResult = false;
                    storageService.setUserFilter($scope.find);

                    return adminUserService.get(
                        $scope.find.NickName,
                        $scope.find.FirstName,
                        $scope.find.LastName,
                        $scope.find.userEnabled,
                        $scope.find.userLocked,
                        $scope.find.organizationalUnitId,
                        null, null,
                        $scope.data.currentPage,
                        $scope.data.itemsPerPage
                    ).then(function getOk(result) {
                        $scope.items = result.value;
                        $scope.data.totalItems = result.totalCount;
                        $scope.data.from = 1 + ($scope.data.itemsPerPage * ($scope.data.currentPage - 1));

                        if ($scope.items.length === 0) {
                            $scope.find.showNoData = true;
                        } else {
                            $scope.find.showResult = true;
                        }

                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.modify = function (userOU) {
                    $state.go('user-modify', { id: userOU.id });
                };

                $scope.view = function (userOU) {
                    $state.go('user-detail', { id: userOU.id });
                };

                $scope.add = function () {
                    $state.go('user-add');
                };

                $scope.unLock = function (user) {
                    return adminUserService.unlock(user).then(function getOk() {
                        errors.showSuccess('UserUnlockSucces');
                        $scope.findAction();
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };
                $scope.resetPassword = function (user) {

                    return adminUserService.reset(user).then(function getOk(result) {
                        errors.showSuccess('UserResetSucces');
                        $scope.findAction();
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };
                $scope.roles = function (user) {
                    $state.go('user-roles', { id: user.id });
                };

                $scope.enable = function (userOU) {
                    return $scope.enable_disable(userOU, true);
                }

                $scope.disable = function (userOU) {
                    return $scope.enable_disable(userOU, false);
                }

                $scope.export = function () {
                    var ids = [];

                    $scope.items.forEach(function (user) {
                        ids.push(user.id);
                    });

                    adminUserService.export($scope.find.NickName, $scope.find.FirstName,
                        $scope.find.LastName,
                        $scope.find.userEnabled,
                        $scope.find.userLocked,
                        $scope.find.organizationalUnitId,
                        null, null,
                        $scope.data.currentPage,
                        $scope.data.itemsPerPage,
                        null,
                        config.appId()).then(function getOk(result) {
                            var d = new Date();
                            var month = d.getUTCMonth() + 1;

                            var success = fileDownloader.saveAs(result.value, 'Listado de Usarios - Roles ' +
                                d.getUTCFullYear() +
                                ("00".substring(0, 2 - (month + '').length) + month) +
                                ("00".substring(0, 2 - (d.getDate() + '').length) + d.getDate()) +
                                '.xlsx');

                            if (!success) {
                                errors.showError('Api failed');
                            }
                        }, function getError(error) {
                            errors.showError(error);
                        });
                };

                $scope.enable_disable = function (userOU, enabled) {
                    return adminUserService.getById(userOU.id).then(function (result) {
                        var userOu = result;
                        userOu.enabled = enabled;

                        return adminUserService.modify(userOu).then(function () {
                            userOU.enabled = enabled;
                            $state.go('user-find');
                        }, function (error) {
                            errors.showError(error);
                        });
                    });
                }

                $scope.load = function () {
                    $scope.find = storageService.getUserFilter();
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemsPerPage: 15,
                        from: 0
                    };

                    $translate(['PaginationNext', 'PaginationPrev', 'PaginationLastFem', 'PaginationFirstFem'])
                        .then(function (translated) {
                            $scope.paginatorTranslations = {
                                nextText: translated.PaginationNext,
                                previousText: translated.PaginationPrev,
                                lastText: translated.PaginationLastFem,
                                firstText: translated.PaginationFirstFem
                            };
                        });

                    $scope.findAction();
                }

                $scope.load();
            }
        ]);
})();